import Categories from './Categories'

export default Categories



// WEBPACK FOOTER //
// ./src/components/Categories/index.js